import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { CheckboxEl } from 'common/components/checkbox';
import { InputGroupEl } from 'common/components/input-group';
import { SpinnerEl } from 'common/components/spinner';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  const checkboxDisabled = this.state.removePasswordLoading || this.state.setPasswordLoading;
  return jsx("div", {
    sel: '.public-dashboard-password-row'
  }, jsx(CheckboxEl, {
    attrs: {
      checked: this.attr("password-protected") || this.state.editingPassword,
      elref: "passwordRowCheckbox_".concat(this.attr("public-link-id")),
      disabled: checkboxDisabled
    },
    on: {
      click: !checkboxDisabled && this.helpers.handleCheckboxClick
    }
  }, "Require Passcode", this.state.removePasswordLoading && jsx(SpinnerEl, null)), jsx("div", {
    sel: '.input-area',
    class: {
      'editing-password': this.state.editingPassword
    }
  }, this.state.editingPassword ? jsx("div", {
    sel: '.edit-password-wrapper'
  }, jsx(InputGroupEl, {
    attrs: {
      elref: "passwordRowInputGroup_".concat(this.attr("public-link-id")),
      label: "Save",
      value: this.state.password,
      busy: this.state.setPasswordLoading,
      disabled: this.state.setPasswordLoading,
      required: true,
      min: 8,
      maxlength: 32,
      'value-type': "passcode",
      'value-type-article': "a"
    },
    on: {
      input: this.helpers.handlePasswordInput,
      submit: this.helpers.handleSaveClick
    },
    sel: '.password-input'
  }), jsx("div", {
    sel: '.password-info-wrapper'
  }, jsx("span", {
    sel: '.info-icon'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "info"
    }
  })), jsx("div", {
    sel: '.info-text-wrapper'
  }, jsx("p", null, " Minimum length of 8 characters."), jsx("p", null, " Passcodes can not be recovered after they are set.")))) : this.attr("password-protected") && jsx("span", {
    sel: '.password-protected-wrapper'
  }, "\u2022\u2022\u2022\u2022\u2022\u2022\u2022", jsx(ButtonEl, {
    sel: '.edit-btn',
    on: {
      click: this.helpers.handleEditClick
    },
    attrs: {
      elref: "linkPasswordResetButton"
    }
  }, "Reset"), this.attr("public-link-embed-link-with-passcode").length ? jsx(ButtonEl, {
    sel: '.edit-btn',
    on: {
      click: () => this.helpers.copyEmbedLink(this.attr("public-link-embed-link-with-passcode"))
    },
    attrs: {
      icon: "duplicate",
      elref: "embedLinkButton"
    }
  }, "Embed Link") : null)));
}